/**
 * @Author: Louis
 * @Date: 2021-09-26 14:57:37
 * @LastEditTime: 2022-07-01 18:33:32
 * @LastEditors: Louis
 * @Description: 终端对时服务
 * @FilePath: \react-project-center\src\components\projects\agency_maintain\service\terminalCheckTimeService.js
 */

import * as HttpService from "../../../../service/HttpService";

/******* 
* @description: 处理GET请求参数拼接
* @param  obj  
* @return {Promise<Response>}
*/
const params = (obj) => {
    let result = '';
    let item;
    for (item in obj) {
        if (obj[item] && String(obj[item])) {
            result += `&${item}=${obj[item]}`;
        }
    }
    if (result) {
        result = '?' + result.slice(1);
    }
    return result;
}

//获取终端对时列表
export const getTerminalCheckTimeList = (param) => {
    return HttpService.get(HttpService.DOMAIN + "/terminalTime/list" + params(param));
};
//终端对时
export const terminalPair = (param) => {
    return HttpService.post(HttpService.DOMAIN + "/terminalTime/terminalPair" ,param);
};
//召测时钟
export const calledMeasuringClock = (param) => {
    return HttpService.post(HttpService.DOMAIN + "/terminalTime/calledMeasuringClock" ,param);
};